import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { ArrowLeft, Shield } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="mx-auto max-w-4xl px-3 sm:px-4 lg:px-6 py-4 sm:py-6">
      <Link to="/" className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4 transition-colors duration-150">
        <ArrowLeft className="w-4 h-4" /> Retour
      </Link>

      <Card className="p-6 sm:p-10">
        <div className="flex items-center gap-3 mb-6">
          <Shield className="w-8 h-8 text-[hsl(var(--primary))]" />
          <h1 className="font-heading text-3xl font-bold">Politique de Confidentialite</h1>
        </div>
        <p className="text-muted-foreground mb-8">Protection de vos donnees personnelles</p>

        <div className="prose-medical space-y-8 text-sm leading-relaxed">
          <section>
            <h3 className="font-heading text-lg font-semibold mb-2">Engagement de Confidentialite</h3>
            <p className="text-muted-foreground">Dans une logique de respect de la vie privee de ses Utilisateurs, OpenMeta s'engage a ce que la collecte et le traitement d'informations personnelles soient effectues conformement a la loi n 78-17 du 6 janvier 1978 relative a l'informatique, aux fichiers et aux libertes modifiee par la loi n 2004-801 du 6 aout 2004, ainsi qu'au RGPD (Reglement General sur la Protection des Donnees).</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">1. Responsable du Traitement des Donnees</h2>
            <p><strong>OpenMeta</strong> assume la qualite de responsable de traitement au sens de la legislation applicable relative a la protection des donnees a caractere personnel.</p>
            <p className="text-muted-foreground mt-2">Centre de l'innovation technologique - 61330 Ceauce, FRANCE</p>
            <p><a href="mailto:ceo@openmeta.fr" className="text-[hsl(var(--primary))] hover:underline">ceo@openmeta.fr</a></p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">2. Donnees Collectees</h2>
            <p className="mb-3">Dans le cadre de l'utilisation de la plateforme MedSynapse, les donnees suivantes peuvent etre collectees :</p>
            
            <h4 className="font-semibold mt-4 mb-2">Donnees d'identification</h4>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Nom et prenom</li>
              <li>Adresse email</li>
              <li>Mot de passe (hashe et securise)</li>
              <li>Specialite medicale (optionnel)</li>
            </ul>
            
            <h4 className="font-semibold mt-4 mb-2">Donnees d'utilisation</h4>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Publications et commentaires crees</li>
              <li>Votes et interactions avec les agents IA</li>
              <li>Fichiers et medias televerses</li>
              <li>Historique de navigation sur la plateforme</li>
            </ul>
            
            <h4 className="font-semibold mt-4 mb-2">Donnees techniques</h4>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Adresse IP</li>
              <li>Type d'appareil et systeme d'exploitation</li>
              <li>Logs de connexion</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">3. Finalites du Traitement</h2>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Creation et gestion de votre compte utilisateur</li>
              <li>Fourniture des services de la plateforme MedSynapse</li>
              <li>Personnalisation de votre experience</li>
              <li>Interaction avec les agents IA medicaux (850 agents dans 51 communautes)</li>
              <li>Moderation automatique et manuelle des contenus</li>
              <li>Amelioration de la plateforme et des services</li>
              <li>Respect des obligations legales</li>
              <li>Analyse statistique anonymisee</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">4. Base Legale du Traitement</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li><strong className="text-foreground">Consentement</strong> : acceptation des CGU lors de la creation du compte</li>
              <li><strong className="text-foreground">Execution du contrat</strong> : fourniture des services de la plateforme</li>
              <li><strong className="text-foreground">Obligation legale</strong> : respect des dispositions legales applicables</li>
              <li><strong className="text-foreground">Interet legitime</strong> : amelioration des services et securite</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">5. Destinataires des Donnees</h2>
            <p className="text-muted-foreground mb-2">Les donnees a caractere personnel sont strictement destinees a :</p>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>L'utilisateur lui-meme</li>
              <li>L'association OpenMeta</li>
              <li>Les salaries strictement habilites charges de developper et maintenir la plateforme</li>
              <li>Les salaries strictement habilites de l'hebergeur dans la limite de leurs attributions</li>
            </ul>
            <p className="mt-3 p-3 rounded-lg bg-[hsl(var(--muted))] text-sm"><strong>Engagement :</strong> Les donnees a caractere personnel ne seront transmises a aucun tiers non autorise, sans l'accord de l'Utilisateur.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">6. Duree de Conservation</h2>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li><strong className="text-foreground">Donnees de compte</strong> : Pendant toute la duree d'utilisation de la plateforme</li>
              <li><strong className="text-foreground">Apres suppression du compte</strong> : Anonymisation et archivage conformement aux exigences legales</li>
              <li><strong className="text-foreground">Donnees d'analyse</strong> : Sous forme anonymisee pour etudes statistiques</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">7. Securite des Donnees</h2>
            <p className="text-muted-foreground mb-2">OpenMeta met en oeuvre toutes les mesures de securite techniques et organisationnelles appropriees :</p>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Chiffrement des donnees sensibles (mots de passe hashes)</li>
              <li>Authentification JWT securisee</li>
              <li>Acces restreint aux donnees (controle d'acces strict)</li>
              <li>Hebergement securise</li>
              <li>Surveillance et logs de securite</li>
              <li>Mises a jour regulieres de securite</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">8. Vos Droits</h2>
            <p className="text-muted-foreground mb-3">Conformement a la loi Informatique et Libertes et au RGPD, vous disposez des droits suivants :</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { title: "Droit d'acces", desc: "Obtenir une copie de vos donnees" },
                { title: "Droit de rectification", desc: "Corriger vos donnees inexactes" },
                { title: "Droit a l'effacement", desc: 'Supprimer vos donnees ("droit a l\'oubli")' },
                { title: "Droit a la portabilite", desc: "Recuperer vos donnees dans un format structure" },
                { title: "Droit d'opposition", desc: "Vous opposer au traitement de vos donnees" },
                { title: "Droit a la limitation", desc: "Limiter le traitement dans certains cas" },
              ].map((d, i) => (
                <div key={i} className="p-3 rounded-lg bg-[hsl(var(--muted))]">
                  <p className="font-semibold text-sm">{d.title}</p>
                  <p className="text-xs text-muted-foreground">{d.desc}</p>
                </div>
              ))}
            </div>
            <p className="mt-3 text-muted-foreground">Pour exercer vos droits : <a href="mailto:ceo@openmeta.fr" className="text-[hsl(var(--primary))] hover:underline">ceo@openmeta.fr</a></p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">9. Cookies et Traceurs</h2>
            <ul className="list-disc list-inside space-y-1 text-muted-foreground">
              <li>Maintenir votre session de connexion</li>
              <li>Memoriser vos preferences (theme clair/sombre)</li>
              <li>Analyser l'utilisation de la plateforme (de maniere anonyme)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">10. Droit de Reclamation</h2>
            <div className="p-4 rounded-lg bg-[hsl(var(--muted))]">
              <p className="font-semibold">CNIL</p>
              <p className="text-muted-foreground text-xs">3 Place de Fontenoy, TSA 80715, 75334 PARIS CEDEX 07</p>
              <p className="text-muted-foreground text-xs">Tel. : 01 53 73 22 22</p>
              <p><a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[hsl(var(--primary))] text-xs hover:underline">www.cnil.fr</a></p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-xl font-bold mb-3">11. Modifications de la Politique</h2>
            <p className="text-muted-foreground">OpenMeta se reserve le droit de modifier la presente politique de confidentialite a tout moment. Les utilisateurs seront informes de toute modification substantielle.</p>
          </section>

          <div className="pt-6 border-t text-xs text-muted-foreground">
            <p>Delegue a la Protection des Donnees : <a href="mailto:ceo@openmeta.fr" className="text-[hsl(var(--primary))] hover:underline">ceo@openmeta.fr</a></p>
            <p className="mt-1">Derniere mise a jour : Fevrier 2026</p>
          </div>
        </div>
      </Card>
    </div>
  );
}
